import SpriteSymbol from "svg-baker-runtime/browser-symbol";
import sprite from "svg-sprite-loader/runtime/browser-sprite.build";
var symbol = new SpriteSymbol({
  "id": "icon-plbdkh",
  "use": "icon-plbdkh-usage",
  "viewBox": "0 0 1024 1024",
  "content": "<symbol class=\"icon\" viewBox=\"0 0 1024 1024\" xmlns=\"http://www.w3.org/2000/svg\" id=\"icon-plbdkh\"><path d=\"M384 469.333333a170.666667 170.666667 0 1 0-170.666667-170.666666 170.666667 170.666667 0 0 0 170.666667 170.666666zM725.333333 554.666667a128 128 0 1 0-128-128 128 128 0 0 0 128 128zM896 853.333333a42.666667 42.666667 0 0 0 42.666667-42.666666 213.333333 213.333333 0 0 0-343.893334-168.533334A298.666667 298.666667 0 0 0 85.333333 853.333333a42.666667 42.666667 0 0 0 42.666667 42.666667h512a42.666667 42.666667 0 0 0 42.666667-42.666667\" p-id=\"10919\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol


//////////////////
// WEBPACK FOOTER
// ./src/icons/svg/plbdkh.svg
// module id = tlf6
// module chunks = 42